import React, { useState } from "react";
import { Link, NavLink, BrowserRouter, useHistory } from "react-router-dom";
import { mergeStyles } from "react-select";
import * as axios from "axios";
import Swal from "sweetalert2";
import CONFIG from "../../config";
import Header from "../../component/Common/Header";
import { getAuthHeader, ToSeoUrl } from "../../utils";
import ModalWindow from "../Common/ModalWindow";
import ModalWindowWithHeader from "../Common/ModalWindowWithHeader";
import NumberFormat from "react-number-format";
import moment from "moment";
import Parser from 'html-react-parser';

const modal = {
  marginTop: '10px'
}

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

export const HomePageLayouts = (props) => {
  console.log("props", props.Data)
  const [vacancy, setVacancy] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [personName, setPersonName] = useState(null);
  const [companyEmail, setCompanyEmail] = useState(null);
  const [companyPhone, setCompanyPhone] = useState(null);
  const [companyAddress, setCompanyAddress] = useState(null);
  const [mobile, setMobile] = useState({ value: '', error: '', success: '' });

  const getCompanyPost = () => {
    return {
      enquiry_type: 2,
      name: personName,
      email: companyEmail,
      phone: companyPhone,
      city: companyAddress,
      message: `Company Name-${companyName}, No. of Vacancy-${vacancy}`
    }
  }

  const getUniversityPost = () => {
    return {
      enquiry_type: 1,
      name: personName,
      email: companyEmail,
      phone: companyPhone,
      city: companyAddress,
      message: `Company Name-${companyName}, No. of Vacancy-${vacancy}`
    }
  }

  const getStudentPost = () => {
    return {
      enquiry_type: 3,
      name: companyName,
      email: companyEmail,
      phone: companyPhone,
      city: `${personName} ${companyAddress}`,
      message: vacancy
    }
  }

  const handleCompanySubmit = (e) => {
    e.preventDefault()
    const jsonToPost = getCompanyPost()
    addEnquiry(jsonToPost)
  }

  const handleUniveristySubmit = (e) => {
    e.preventDefault()
    const jsonToPost = getUniversityPost()
    addEnquiry(jsonToPost)
  }

  const handleStudentPostSubmit = (e) => {
    e.preventDefault()
    const jsonToPost = getStudentPost()
    addEnquiry(jsonToPost)

  }

  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [city, setCity] = useState(null);
  const [message, setMessage] = useState(null);
  const [tab, setTab] = useState('Companies');
  const [showPopUp, SetShowPopUp] = useState(true)

  const getStudentEnquiryPost = () => {
    return {
      enquiry_type: 3,
      name: name,
      email: email,
      phone: phone,
      city: city,
      message: message,
    };
  }

  const sendLink = async () => {

    if (mobile.value.length >= 10) {
      const res = await axios.post(`https://sms.rozgar.com/send-app-download-link`, { mobile: mobile.value })
      if (res.data.type === 'success') {
        setMobile({ ...mobile, success: `We have successfully sent App Download link to ${mobile.value}` })
      }

    }
    else {
      setMobile({ ...mobile, error: `Please enter a valid mobile number` })

    }
  }
  const getJsonToPost = () => {
    return {
      enquiry_type: 2,
      name: name,
      email: email,
      phone: phone,
      city: city,
      message: message,
    };
  };

  const getUniversityEnquiryPost = () => {
    return {
      enquiry_type: 1,
      name: name,
      email: email,
      phone: phone,
      city: city,
      message: message,
    };
  };




  const handleSubmit = (e) => {
    e.preventDefault();
    const jsonToPost = getJsonToPost();
    addEnquiry(jsonToPost);

  };

  const universitysubmit = (e) => {
    e.preventDefault();
    const jsonToPost = getUniversityEnquiryPost();
    addEnquiry(jsonToPost);

  };

  const studentEnquirySubmit = (e) => {
    e.preventDefault();
    const jsonToPost = getStudentEnquiryPost();
    addEnquiry(jsonToPost);

  }

  const addEnquiry = (jsonToPost) => {
    addenquiryAPI(jsonToPost).then((res) => {
      if (res.status) {
        Swal.fire({
          icon: "success",
          title: "Done",
          text: "Congratulations!",
          footer: "Enquiry has been submitted sucessfully.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please fill the details",
          footer: res.message,
        });
      }
      setVacancy('')
      setCompanyName('')
      setPersonName('')
      setCompanyEmail('')
      setCompanyPhone('')
      setCompanyAddress('')
      setName('')
      setEmail('')
      setPhone('')
      setCity('')
      setMessage('')
    });
  };

  const addenquiryAPI = (model) => {
    const url = `${CONFIG.BASE_URL}/enquiry/add-enquiry`;
    return axios.post(url, model, getAuthHeader()).then((response) => {
      return response.data;
    });
  };

  const [universityModal, setUniversityModal] = useState(false)
  const [companiesModal, setCompaniesModal] = useState(false)
  const [studentsModal, setStudentsModal] = useState(false)

  const setBackground = (tab) => {
    setTab(tab)
    SetShowPopUp(false)
  }
  return (
    <React.Fragment class='login-modal-index'>

      <Header />

      {companiesModal && <ModalWindowWithHeader title='Post a Job'>
        <form className="universityformbox">
          <div class="form-group">
            <label for="formno1">No. of Vacancy</label>
            <input
              type="text"
              value={vacancy}
              name='vacancy'
              onChange={(e) => setVacancy(e.target.value)}
              class="form-control"
              id="formno1"
              placeholder="No. of Vacancy"
            />
          </div>
          <div class="form-group">
            <label for="formno2">Company Name</label>
            <input
              type="text"
              name={companyName}
              value={companyName}
              validations={[required]}
              onChange={(e) => setCompanyName(e.target.value)}
              class="form-control"
              id="formno2"
              placeholder="Company Name"
            />
          </div>
          <div class="form-group">
            <label for="formno3">Contact Person Name</label>
            <input
              type="text"
              value={personName}
              name='personName'
              onChange={(e) => setPersonName(e.target.value)}
              class="form-control"
              id="formno3"
              placeholder="Contact Person Name"
            />
          </div>
          <div class="form-group">
            <label for="formno4">Email</label>
            <input
              type="email"
              value={companyEmail}
              name="companyEmail"
              onChange={(e) => setCompanyEmail(e.target.value)}
              class="form-control"
              id="formno4"
              placeholder="Email"
            />
          </div>
          <div class="form-group">
            <label for="formno3">Phone</label>
            <NumberFormat
              maxLength={10}
              minLength={10}
              value={companyPhone}
              name='companyPhone'
              onChange={(e) => setCompanyPhone(e.target.value)}
              class="form-control"
              id="formno3"
              placeholder="Phone"
            />
          </div>
          <div class="form-group">
            <label for="formno3">Address</label>
            <input
              type="text"
              name="companyAddress"
              value={companyAddress}
              validations={[required]}
              onChange={(e) => setCompanyAddress(e.target.value)}
              class="form-control"
              id="formno3"
              placeholder="Address"
            />
          </div>
          <div class="form-group mt-4">
            <a href="javascript:void();" class="submit-btn-univer" onClick={handleCompanySubmit}>Submit</a>
          </div>
        </form>
      </ModalWindowWithHeader>}

      {
        universityModal && <ModalWindowWithHeader title='Post a Requirement - New University / Institution'>
          <form className="universityformbox">
            <div class="form-group">
              <label for="formno1">No. of Placement Required?</label>
              <input
                type="text"
                value={vacancy}
                name='vacancy'
                onChange={(e) => setVacancy(e.target.value)}
                class="form-control"
                id="formno2"
                placeholder="No. of Placement Required?"
              />
            </div>
            <div class="form-group">
              <label for="formno2">University/Insution Name</label>
              <input
                type="text"
                name={companyName}
                value={companyName}
                validations={[required]}
                onChange={(e) => setCompanyName(e.target.value)}
                class="form-control"
                id="formno2"
                placeholder="University/Insution Name"
              />
            </div>
            <div class="form-group">
              <label for="formno3">Contact Person Name</label>
              <input
                type="text"
                value={personName}
                name='personName'
                onChange={(e) => setPersonName(e.target.value)}
                class="form-control"
                id="formno3"
                placeholder="Contact Person Name"
              />
            </div>
            <div class="form-group">
              <label for="formno3">Email</label>
              <input
                type="email"
                value={companyEmail}
                name="companyEmail"
                onChange={(e) => setCompanyEmail(e.target.value)}
                class="form-control"
                id="formno3"
                placeholder="Email"
              />
            </div>
            <div class="form-group">
              <label for="formno3">Phone</label>
              <NumberFormat
                maxLength={10}
                minLength={10}
                value={companyPhone}
                name='companyPhone'
                onChange={(e) => setCompanyPhone(e.target.value)}
                class="form-control"
                id="formno3"
                placeholder="Phone"
              />
            </div>
            <div class="form-group">
              <label for="formno3">Address</label>
              <input
                type="text"
                name={companyAddress}
                value={companyAddress}
                validations={[required]}
                onChange={(e) => setCompanyAddress(e.target.value)}
                class="form-control"
                id="formno3"
                placeholder="Address"
              />
            </div>
            <div class="form-group mt-4">
              <a href="javascript:void();" class="submit-btn-univer" onClick={handleUniveristySubmit}>Submit</a>
            </div>
          </form>
        </ModalWindowWithHeader>
      }

      {
        studentsModal && <ModalWindowWithHeader title='New Student'>
          <form className="universityformbox">
            <div class="form-group">
              <label for="formno2">University/Institute Name</label>
              <input
                type="text"
                value={companyName}
                name='companyName'
                onChange={(e) => setCompanyName(e.target.value)}
                class="form-control"
                id="formno2"
                placeholder="University/Institute Name"
              />
            </div>
            <div class="form-group">
              <label for="formno3">First Name</label>
              <input
                type="text"
                value={personName}
                name='personName'
                onChange={(e) => setPersonName(e.target.value)}
                class="form-control"
                id="formno3"
                placeholder="First Name"
              />
            </div>
            <div class="form-group">
              <label for="formno3">Last Name</label>
              <input
                type="text"
                value={companyAddress}
                name='companyAddress'
                onChange={(e) => setCompanyAddress(e.target.value)}
                class="form-control"
                id="formno3"
                placeholder="Last Name"
              />
            </div>
            <div class="form-group">
              <label for="formno3">Email</label>
              <input
                type="email"
                value={companyEmail}
                name='companyEmail'
                onChange={(e) => setCompanyEmail(e.target.value)}
                class="form-control"
                id="formno3"
                placeholder="Email"
              />
            </div>
            <div class="form-group">
              <label for="formno3">Phone</label>
              <NumberFormat
                maxLength={10}
                minLength={10}
                value={companyPhone}
                name='companyPhone'
                onChange={(e) => setCompanyPhone(e.target.value)}
                class="form-control"
                id="formno3"
                placeholder="Phone"
              />
            </div>
            <div class="form-group">
              <label for="formno3">Resume</label>
              <input
                type="file"
                value={vacancy}
                name='vacancy'
                onChange={(e) => setVacancy(e.target.value)}
                class="form-control pb-5 py-4"
              />
            </div>
            <div class="form-group mt-4">
              <a href="javascript:void();" class="submit-btn-univer" onClick={handleStudentPostSubmit}>Submit</a>
            </div>
          </form>
        </ModalWindowWithHeader>
      }


      {
        showPopUp &&
        <div className="test"> <ModalWindow style={{ width: '300px' }} className='login-modal-index' >
          <div className="are-you-modal-box">

            <div className="are-you-tab-box">

              <div className="ar-box">
                <h4 className="are-you-box">Tell Us Who You Are?</h4>
                {/* <p><i>Choose one</i> </p> */}

              </div>

              <div className="tab-bx">
                <p><a className="" href="javascript:void(0);" onClick={() => setBackground('Companies')}> <span className='check-box-input'> <input type="radio" class="form-check-input" id="radio1" name="optradio" value="option1" /> </span> <span className="span-tab-d">A Company <small>Looking for your ideal candidate??</small></span></a></p>
                <p> <a className="" href="javascript:void(0);" onClick={() => setBackground('Universities')}>  <span className='check-box-input'> <input type="radio" class="form-check-input" id="radio1" name="optradio" value="option1" /> </span> <span className="span-tab-d">A University <small>Need support for placements?</small></span></a></p>

                <p> <a className="" href="javascript:void(0);" onClick={() => setBackground('Students')}> <span className='check-box-input'> <input type="radio" class="form-check-input" id="radio1" name="optradio" value="option1" /> </span> <span className="span-tab-d">A Student <small>Looking for your dream job?</small></span></a></p>
              </div>

            </div>

          </div>

        </ModalWindow>
        </div>
      }


      {
        tab === 'Companies' && <section className="companiesbanner">
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <div className="enquiryhead">
                  <h4><span>Are You</span></h4>
                </div>
                <div className="left-are-you-tab-box">
                  <p><a className="btontab active" href="javascript:void(0);" onClick={() => setBackground('Companies')}>Company <i className='fa fa-chevron-right'></i></a></p>
                  <p><a className="btontab" href="javascript:void(0);" onClick={() => setBackground('Universities')} >University <i className='fa fa-chevron-right'></i></a></p>
                  <p><a className="btontab" href="javascript:void(0);" onClick={() => setBackground('Students')}>Student <i className='fa fa-chevron-right'></i></a></p>
                </div>

                <div className="enquiryhead mt-4">
                  <h4><span>Contact Us</span></h4>
                </div>
                <div className="left-are-you-tab-box">
                  <p><i class="bi bi-envelope-open"></i> &nbsp;contact@rozgar.com</p>
                  <p><i class="bi bi-telephone"></i> &nbsp;+91 - 7777004946 <br />
                    &nbsp;&nbsp;&nbsp; &nbsp; +91 - 9311744658</p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="services-banner-box" style={{ background: '#ffffff url(assets/home/companies.png) no-repeat', backgroundPosition: 'bottom 40px right -10px', backgroundSize: '55%' }}>
                  <div className="servicesbox">
                    <h2>Are you searching for your ideal candidate?</h2>
                    <div className="loginuniver-box">
                      <span className="loginuniver">Existing company<a href="/login" class="loginuniver-button">Login</a></span>
                      <span className="loginuniver-req">New company<a href="javascript:void(0)" onClick={() => { setCompaniesModal(!companiesModal) }} class="loginuniver-req-btn">Tell Us Your Requirements</a></span>
                    </div>
                    {/* <div className="loginpost-box">
                    <span className="loginpost">Existing Company<a href="/login" class="loginpost-button">Login</a></span>
                    <span className="loginpost-req">New Company<a href="javascript:void();"  onClick ={()=>{setCompaniesModal(!companiesModal)}} class="loginpost-req-btn">Post a Job</a></span>
                  </div> */}

                    <ul>
                      <li><i class="bi bi-check2-circle"></i> Job Posting</li>
                      <li><i class="bi bi-check2-circle"></i> Schedule Campus Drives</li>
                      <li><i class="bi bi-check2-circle"></i> Internship</li>
                      <li><i class="bi bi-check2-circle"></i> Manage Job Applications</li>
                    </ul>

                  </div>
                  {/* <div className="companies">
                  <img src={'./assets/home/companies.png'} />
                </div> */}
                </div>
              </div>
              <div className="col-md-3">
                <div className="enquiryhead">
                  <h4><span>Click for an enrollment</span></h4>
                </div>

                <form className="form-group" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type='text'
                      value={name}
                      // name='comName'
                      onChange={(e) => setName(e.target.value)}
                      className="form-control"
                      placeholder="Name of the company"
                      validations={[required]}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type='email'
                      value={email}
                      // name='comEmail'
                      validations={[required]}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control"
                      placeholder="Email Id"
                    />
                  </div>
                  <div className="form-group">
                    <NumberFormat
                      // type='number'
                      value={phone}
                      // name='comMob'
                      maxLength={10}
                      minLength={10}
                      validations={[required]}
                      onChange={(e) => setPhone(e.target.value)}
                      className="form-control"
                      placeholder="Mobile No."
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type='text'
                      value={city}
                      // name='comCity'
                      validations={[required]}
                      onChange={(e) => setCity(e.target.value)}
                      className="form-control"
                      placeholder="Your city"
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      value={message}
                      // name='comMessage'
                      validations={[required]}
                      onChange={(e) => setMessage(e.target.value)}
                      className="form-control"
                      placeholder="Message"
                    >
                    </textarea>
                  </div>
                  <button class="send-button">Enquiry Now</button>
                </form>
              </div>
            </div>
          </div>
        </section>
      }

      {
        tab === 'Universities' && <section className="universitybanner">
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <div className="enquiryhead">
                  <h4><span>Are You</span></h4>
                </div>
                <div className="left-are-you-tab-box">
                  <p><a className="btontab" href="javascript:void(0);" onClick={() => setBackground('Companies')}>Company <i className='fa fa-chevron-right'></i></a></p>
                  <p><a className="btontab active" href="javascript:void(0);" onClick={() => setBackground('Universities')} >University <i className='fa fa-chevron-right'></i></a></p>
                  <p><a className="btontab" href="javascript:void(0);" onClick={() => setBackground('Students')}>Student <i className='fa fa-chevron-right'></i></a></p>
                </div>

                <div className="enquiryhead mt-4">
                  <h4><span>Contact Us</span></h4>
                </div>
                <div className="left-are-you-tab-box">
                  <p><i class="bi bi-envelope-open"></i> &nbsp;contact@rozgar.com</p>
                  <p><i class="bi bi-telephone"></i> &nbsp;+91 - 77770 04946 <br />
                    &nbsp;&nbsp;&nbsp; &nbsp; +91 - 9311744658</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="services-banner-box" style={{ background: '#ffffff url(assets/home/university.png) no-repeat', backgroundPosition: 'bottom 10px right 10px', backgroundSize: '40%' }}>
                  <div className="servicesbox">
                    <h2>Are you in need for support for placements?</h2>
                    <div className="loginuniver-box">
                      <span className="loginuniver">Existing University/Institute
                        <div className="Uni-Ins-box">
                          <a href="/login" class="Uni-Ins-button">Login</a>
                          <a href="/university_Register" class="Uni-Ins-button-R">Register</a>
                        </div>
                      </span>
                      <span className="loginuniver-req">New University/Institute<a href="javascript:void(0)" onClick={() => { setUniversityModal(!universityModal) }} class="loginuniver-req-btn">Tell Us Your Requirements</a></span>
                    </div>
                    <ul>
                      <li><i class="bi bi-check2-circle"></i> Job Posting</li>
                      <li><i class="bi bi-check2-circle"></i> Registration for Bulk Candidates</li>
                      <li><i class="bi bi-check2-circle"></i> Affiliate College/Institute Management</li>
                    </ul>
                  </div>
                  {/* <div className="university">
                  <img src={'./assets/home/university.png'} />
                </div> */}
                </div>
              </div>
              <div className="col-md-3">
                <div className="enquiryhead">
                  <h4><span>Click for an enrollment</span></h4>
                </div>

                <form className="form-group" onSubmit={universitysubmit}>
                  <div className="form-group">
                    <input
                      type='text'
                      value={name}
                      // name='uniName'
                      onChange={(e) => setName(e.target.value)}
                      validations={[required]}
                      className="form-control"
                      placeholder="Name of the university / institute"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type='email'
                      value={email}
                      // name='uniEmail'
                      validations={[required]}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control"
                      placeholder="Email Id"
                    />
                  </div>
                  <div className="form-group">
                    <NumberFormat
                      // type='number'
                      value={phone}
                      // name='uniMob'
                      maxLength={10}
                      minLength={10}
                      validations={[required]}
                      onChange={(e) => setPhone(e.target.value)}
                      className="form-control"
                      placeholder="Mobile No."
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type='text'
                      value={city}
                      // name='uniCity'
                      validations={[required]}
                      onChange={(e) => setCity(e.target.value)}
                      className="form-control"
                      placeholder="Your city"
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      value={message}
                      // name='uniMessage'
                      validations={[required]}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Message"
                    >

                    </textarea>
                  </div>
                  <button class="send-button">Enquiry Now</button>
                </form>
              </div>
            </div>
          </div>
        </section>
      }
      {
        tab === 'Students' && <section className="studentsbanner">
          <div className="container">
            <div className="row">
              <div className="col-md-3">
                <div className="enquiryhead">
                  <h4><span>Are You</span></h4>

                </div>
                <div className="left-are-you-tab-box">
                  <p><a className="btontab" href="javascript:void(0);" onClick={() => setBackground('Companies')}>Company <i className='fa fa-chevron-right'></i></a></p>
                  <p><a className="btontab" href="javascript:void(0);" onClick={() => setBackground('Universities')} >University <i className='fa fa-chevron-right'></i></a></p>
                  <p><a className="btontab active" href="javascript:void(0);" onClick={() => setBackground('Students')}>Student <i className='fa fa-chevron-right'></i></a></p>
                </div>

                <div className="enquiryhead mt-4">
                  <h4><span>Contact Us</span></h4>
                </div>
                <div className="left-are-you-tab-box">
                  <p><i class="bi bi-envelope-open"></i> &nbsp;contact@rozgar.com</p>

                  <p><i class="bi bi-telephone"></i> &nbsp;+91 - 77770 04946 <br />
                    &nbsp;&nbsp;&nbsp; &nbsp; +91 - 9311744658</p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="services-banner-box" style={{ background: '#ffffff url(assets/home/students.png) no-repeat', backgroundPosition: 'bottom 20px right 20px', backgroundSize: '40%' }}>
                  <div className="servicesbox">
                    <h2>Are you looking for your dream job?</h2>
                    <div className="loginuniver-box">
                      <span className="loginuniver">Existing Student<a href="/login" class="loginuniver-button">Login</a></span>
                      <span className="loginuniver-req">New Student<a href="javascript:void(0)" onClick={() => { setStudentsModal(!studentsModal) }} class="loginuniver-req-btn">Sign Up</a></span>
                    </div>
                    {/* <div className="loginpost-box">
                    <span className="loginpost">Existing Student<a href="/login" class="loginpost-button">Login</a></span>
                    <span className="loginpost-req">New Student<a href="javascript:void(0)" onClick ={()=>{setStudentsModal(!studentsModal)}} class="loginpost-req-btn">Signup</a></span>
                  </div> */}
                    <ul>
                      <li><i class="bi bi-check2-circle"></i> Apply for Jobs &amp; Internships</li>
                      <li><i class="bi bi-check2-circle"></i> Professional Job Profile Management</li>
                      <li><i class="bi bi-check2-circle"></i> Campus Drive Participation</li>
                    </ul>
                  </div>
                  {/* <div className="students">
                  <img src={'./assets/home/students.png'} />
                </div> */}
                </div>
              </div>
              <div className="col-md-3">
                <div className="enquiryhead">
                  <h4><span>Click for an enrollment</span></h4>
                </div>
                <form className="form-group" onSubmit={studentEnquirySubmit}>
                  <div className="form-group">
                    <input
                      type='text'
                      value={name}
                      // name='stuName'
                      validations={[required]}
                      onChange={(e) => setName(e.target.value)}
                      className="form-control"
                      placeholder="Student name"
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type='email'
                      value={email}
                      // name='stuEmail'
                      validations={[required]}
                      onChange={(e) => setEmail(e.target.value)}
                      className="form-control"
                      placeholder="Email Id"
                    />
                  </div>
                  <div className="form-group">
                    <NumberFormat
                      // type='number'
                      value={phone}
                      maxLength={10}
                      minLength={10}
                      // name='stuMob'
                      validations={[required]}
                      onChange={(e) => setPhone(e.target.value)}
                      className="form-control"
                      placeholder="Mobile No."
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type='text'
                      value={city}
                      // name='stucolName'
                      validations={[required]}
                      onChange={(e) => setCity(e.target.value)}
                      className="form-control"
                      placeholder="Student college name"
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      value={message}
                      // name='stuMessage'
                      onChange={(e) => setMessage(e.target.value)}
                      className="form-control"
                      placeholder="Message"
                    >
                    </textarea>
                  </div>
                  <button class="send-button">Enquiry Now</button>
                </form>
              </div>
            </div>
          </div>
        </section>
      }


      <section className="campus-Ongoing-drive">
        <div className="container">
          <div className="row">
            <div className="container">
              <div className="col-md-12">
                <h4 className="codhead">Latest Fresher Jobs</h4>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-8">

                {props?.Data.map((item) => {
                  const rozgarLink = 'https://rozgar.com'
                  const constant = '/job-detail/:url'
                  const d1 = item.KEYWORDS.split(",")
                  const URL = item.COMPANY_URL ? item.COMPANY_URL + '-' + item.EMPLOYER_ID : 'rozgar' + '-' + item.EMPLOYER_ID;
                  let dynamicURL = ToSeoUrl(item.JOB_TITLE) + '-' + item.COMPANY_URL + '-' + item.CITY.toLowerCase().split(',').join('-') + '-' + ToSeoUrl(item.WORK_EXP_MIN) + '-' + 'to' + '-' + ToSeoUrl(item.WORK_EXP_MAX) + '-' + 'years' + '-' + item.CUSTOM_JOB_ID.slice(4) + '?src-LIST-' + item.JOB_ID
                  dynamicURL = dynamicURL.replace(/ /g, '')

                  return (
                    <div className="campusjob">
                      <div className="CCdetailbox">
                        {/* <h4>Amazon CS-Off Campus Drive First time in Chennai</h4> */}
                        <h6><a href={`${rozgarLink}${constant}`.replace(':url', dynamicURL)} target='_blank'>{item.JOB_TITLE}</a></h6>

                        <div className="companyrating">
                          <article>
                            <span>{item.COMPANY_NAME}</span>
                            <span>
                              <i className="fa fa-star"></i>
                            </span>
                            <span className="reviewnum"><a href={`${rozgarLink}${constant}`.replace(':url', dynamicURL)}>(0 Reviews)</a></span>
                          </article>
                        </div>
                      </div>
                      <div className="cclogo" >
                        <article >
                          {item.COMPANY_LOGO === 'NA' ? <h3 className='logotext'>{item.COMPANY_NAME?.split(' ').map((i) => i.substring(0, 1)).join('')}</h3> : <img src={`https://cp-api.rozgar.com/company/logo/${item.COMPANY_LOGO}`} alt={item.COMPANY_NAME} width="80px" height="80px" />}
                        </article>
                      </div>
                      <div className="yarpa">
                        <ul>
                          <li><i class="bi bi-briefcase"></i> {item.WORK_EXP_MIN} - {item.WORK_EXP_MAX} years</li>
                          <li>&#x20B9; {item.CTC_MIN}-{item.CTC_MAX} PA.</li>
                          <li><i class="bi bi-geo-alt"></i> {item.CITY ? item.CITY?.split(' ').map((i) => i.substring(0, 1)).join('') : null}</li>
                        </ul>
                      </div>
                      <div className="shift-text">
                        {/* <i class="bi bi-file-text"></i> Shifts: 24*7 rotational shifts, must be comfortable working in night shiftsNight Shift ... */}
                        <i class="bi bi-file-text"></i> {item.JOB_DETAILS ? item.JOB_DETAILS?.length > 100 ? Parser(item.JOB_DETAILS.slice(0, 100)) + '...' : Parser(item.JOB_DETAILS) : ''}

                      </div>
                      <ul class="tags has-description">
                        {d1.map((i) => (
                          <li class="fleft fs12 grey-text lh16 dot">{i}</li>
                        ))}
                      </ul>

                      <div className="postday-enquiry">
                        <div className="postdate">
                          <span><i class="bi bi-clock-history"></i> {moment(item.CREATED_ON).fromNow()}</span>
                        </div>
                        <div className="enquirybtn">
                          <a href={`${rozgarLink}${constant}`.replace(':url', dynamicURL)} target='_blank'>Apply Now</a>
                        </div>
                      </div>
                    </div>
                  )
                })}
                <div className="col-md-12">
                  <div className="view-all-btn">
                    <a target="_blank" href="https://rozgar.com/jobs/fresher">View All</a>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-8">
                <div className="campusjob">
                  <div className="CCdetailbox">
                    <h4>Amazon CS-Off Campus Drive First time in Chennai</h4>
                    <div className="companyrating">
                      <article>
                        <span>Amazon</span>
                        <span>4.2 <i className="fa fa-star"></i></span>
                        <span className="reviewnum"><a href="">(16174 Reviews)</a></span>
                      </article>
                    </div>
                  </div>
                  <div className="cclogo">
                    <article>
                      <a href="#"><img src={'./assets/home/398058.gif'} /></a>
                    </article>
                  </div>
                  <div className="yarpa">
                    <ul>
                      <li><i class="bi bi-briefcase"></i> 0-5 years</li>
                      <li>&#x20B9; 2,00,000-3,00,000 PA.</li>
                      <li><i class="bi bi-geo-alt"></i> Remote</li>
                    </ul>
                  </div>
                  <div className="shift-text">
                    <i class="bi bi-file-text"></i> Shifts: 24*7 rotational shifts, must be comfortable working in night shiftsNight Shift ...
                  </div>
                  <ul class="tags has-description">
                    <li class="fleft fs12 grey-text lh16 dot">Customer Support</li>
                    <li class="fleft fs12 grey-text lh16 dot">BPO</li>
                    <li class="fleft fs12 grey-text lh16 dot">customer service</li>
                    <li class="fleft fs12 grey-text lh16 dot">voice</li>
                    <li class="fleft fs12 grey-text lh16 dot">non voice process</li>
                    <li class="fleft fs12 grey-text lh16 dot">fresher</li>
                    <li class="fleft fs12 grey-text lh16 dot">Domestic BPO</li>
                    <li class="fleft fs12 grey-text lh16 dot">Semi Voice</li>
                  </ul>

                  <div className="postday-enquiry">
                    <div className="postdate">
                      <span><i class="bi bi-clock-history"></i> 1 day ago</span>
                    </div>
                    <div className="enquirybtn">
                      <a href="#">Apply Now</a>
                    </div>
                  </div>
                </div>
                <div className="campusjob">
                  <div className="CCdetailbox">
                    <h4>Vaco Binary Semantics Campus Drive 2022</h4>
                    <div className="companyrating">
                      <article>
                        <span>Vaco Binary Semantics LLP</span>
                        <span>4.2 <i className="fa fa-star"></i></span>
                        <span className="reviewnum"><a href="">(16174 Reviews)</a></span>
                      </article>
                    </div>
                  </div>
                  <div className="cclogo">
                    <article>
                      <a href="#"><img src={'./assets/home/4106262.gif'} /></a>
                    </article>
                  </div>
                  <div className="yarpa">
                    <ul>
                      <li><i class="bi bi-briefcase"></i> 0-4 years</li>
                      <li>&#x20B9; 2,00,000-3,00,000 PA.</li>
                      <li><i class="bi bi-geo-alt"></i> Gurgaon/Gurugram</li>
                    </ul>
                  </div>
                  <div className="shift-text">
                    <i class="bi bi-file-text"></i> Shifts: 24*7 rotational shifts, must be comfortable working in night shiftsNight Shift ...
                  </div>
                  <ul class="tags has-description">
                    <li class="fleft fs12 grey-text lh16 dot">fresher</li>
                    <li class="fleft fs12 grey-text lh16 dot">Customer Care</li>
                  </ul>
                  <div className="postday-enquiry">
                    <div className="postdate">
                      <span><i class="bi bi-clock"></i> 1 day ago</span>
                    </div>
                    <div className="enquirybtn">
                      <a href="#">Apply Now</a>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="view-all-btn">
                    <a target="_blank" href="https://rozgar.com/jobs/fresher">View All</a>
                  </div>
                </div>
              </div> */}
              <div className="col-md-4">
                <div className="asisecampusjob">
                  <div className="imgtext">
                    <h4>Get Personalised Job Recommendations</h4>
                    <img src={'./assets/home/recc-jobs.png'} />
                  </div>
                  <p>Registering gives you the benefit to browse & apply variety of jobs based on your preferences</p>
                  <a href="https://www.rozgar.com/register" target="_blank" className="asideregisternow">Register Now</a>
                </div>
                <div className="asisecompanyjob">
                  <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h3 style={{ marginBottom: '0px' }}>Jobs in Featured Companies</h3>
                    <div className="view-all-btn">
                      <a target="_blank" href="https://rozgar.com/list/companies" style={{ color: 'white' }}>View All</a>
                    </div>
                  </p>
                  <div className="comlogo">
                    {props?.Feature.map((item) => (
                      <a target="_blank" href={`https://rozgar.com/jobs-in-url`.replace("url", item.URL)}>
                        <img src={`https://cp-api.rozgar.com/company/logo/${item.COMPANY_LOGO}`} alt={item.COMPANY_NAME} width="51px" height='50px' />
                      </a>
                    ))}

                    {/* <a href="">
                      <img src={'./assets/home/hdfc-logo.jpg'} />
                    </a>
                    <a href="">
                      <img src={'./assets/home/honda-logo.jpg'} />
                    </a>
                    <a href="">
                      <img src={'./assets/home/icici-logo.jpg'} />
                    </a>
                    <a href="">
                      <img src={'./assets/home/iica-logo.jpg'} />
                    </a>
                    <a href="">
                      <img src={'./assets/home/ima-logo.jpg'} />
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* <section className="hero-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="bannertext">
                <h1 className="text-black">Placement. Delivered.</h1>
                  <p>Universities to Campus Solutions.</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="banner-form p-4 shadow">

                <ul className="nav" id="myTab" role="tablist">
                  <li className="nav-item homelink">
                    <a
                      className="nav-link active"
                      id="home-tab"
                      data-toggle="tab"
                      href="#home"
                      role="tab"
                      aria-controls="home"
                      aria-selected="true"
                    >
                      University
                    </a>
                  </li>
                  <li className="nav-item homelink">
                    <a
                      className="nav-link"
                      id="profile-tab"
                      data-toggle="tab"
                      href="#profile"
                      role="tab"
                      aria-controls="profile"
                      aria-selected="false"
                    >
                      Company
                    </a>
                  </li>
                </ul>
                <div className="tab-content form-input" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <form
                      action=""
                      className="form-group mb-0"
                      onSubmit={universitysubmit}
                    >
                      <input
                        type="text"
                        className="border-0 mb-2 form-control"
                        placeholder="Name of the University / Institute"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        validations={[required]}
                      />
                      <input
                        type="email"
                        className="border-0 mb-2  form-control"
                        placeholder="E-mail Id"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        validations={[required]}
                      />
                      <input
                        type="text"
                        className="border-0 mb-2  form-control"
                        placeholder="Contact Number"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        validations={[required]}
                      />
                      <input
                        type="text"
                        className="border-0 mb-2  form-control"
                        placeholder="City"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        validations={[required]}
                      />
                      <textarea
                        className="border-0 mb-2  form-control"
                        placeholder="Message"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        validations={[required]}
                      ></textarea>
                      <div className="d-flex justify-content-end">
                        <button className="send-button">Submit</button>
                      </div>
                    </form>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <form className="form-group mb-0" onSubmit={handleSubmit}>
                      <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        validations={[required]}
                        className="border-0 mb-2  form-control"
                        placeholder="Name of the Company"
                      />
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        validations={[required]}
                        className="border-0 mb-2  form-control"
                        placeholder="E-mail Id"
                      />
                      <input
                        type="text"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        validations={[required]}
                        className="border-0 mb-2  form-control"
                        placeholder="Contact Number"
                      />
                      <input
                        type="text"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        validations={[required]}
                        className="border-0 mb-2  form-control"
                        placeholder="City"
                      />
                      <textarea
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        validations={[required]}
                        className="border-0 mb-2   form-control"
                        placeholder="Message"
                      ></textarea>
                      <div className="d-flex justify-content-end">
                        <button className="send-button">Submit</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}


      <section class="py-5 background-image">
        <div class="container">
          <div class="title-area text-center pb-3">
            <div class="sec-pills">
              <div class="pill"></div>
              <div class="pill"></div>
              <div class="pill"></div>
            </div>
            <h2 class="sec-title">Who is it for?</h2>
          </div>
        </div>
        <div class="container position-relative">
          <div class="process-shape1 d-none d-lg-block"><img src="assets/img/process-shape-1-1.png" alt="shape" /></div>
          <div class="row justify-content-space py-2">
            <div class="col-md-4 col-lg-auto process-style1">
              <div class="process-body">
                <div class="process-shape"></div>
                <div class="process-icon"><img src="assets/img/pro-1-1.png" alt="icon" /></div>
                <p class="process-text">University</p>
              </div>
            </div>
            <div class="col-md-4 col-lg-auto process-style1">
              <div class="process-body">
                <div class="process-shape"></div>
                <div class="process-icon"><img src="assets/img/pro-1-2.png" alt="icon" /></div>
                <p class="process-text">Institute</p>
              </div>
            </div>
            <div class="col-md-4 col-lg-auto process-style1">
              <div class="process-body">
                <div class="process-shape"></div>
                <div class="process-icon"><img src="assets/img/pro-1-3.png" alt="icon" /></div>
                <p class="process-text">Recruiter</p>
              </div>
            </div>
            <div class="col-md-4 col-lg-auto process-style1">
              <div class="process-body">
                <div class="process-shape"></div>
                <div class="process-icon"><img src="assets/img/pro-1-4.png" alt="icon" /></div>
                <p class="process-text">Employer</p>
              </div>
            </div>
            <div class="col-md-4 col-lg-auto process-style1">
              <div class="process-body">
                <div class="process-shape"></div>
                <div class="process-icon"><img src="assets/img/pro-1-5.png" alt="icon" /></div>
                <p class="process-text">Candidate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="about-us" id="about">
        <div class="container">
          <div class="row padding-top ">

            <div class="col-12 col-lg-3 wow fadeInLeft" data-wow-delay="400ms" style={{ visibility: 'visible', animationDelay: "400ms", animationName: "fadeInLeft" }}>
              <a href="javascript:void(0);">
                <div class="card box text-center">
                  <div class="feature-icon text-center">
                    <img src="assets/home/placement.png" alt="icon" />
                  </div>
                  <div class="card-body">
                    <p class="card-text sub-heading text-black">7000+<br />Placements</p>
                  </div>
                </div>
              </a>
            </div>

            <div class="col-12 col-lg-3 wow fadeInDown" data-wow-delay="400ms" style={{ visibility: 'visible', animationDelay: "400ms", animationName: 'fadeInDown' }}>
              <a href="javascript:void(0);">
                <div class="card box text-center">
                  <div class="feature-icon text-center">
                    <img src="assets/home/collaboration.png" alt="icon" />
                  </div>
                  <div class="card-body">
                    <p class="card-text sub-heading text-black">Collab with<br />AKTU</p>
                  </div>
                </div>
              </a>
            </div>

            <div class="col-12 col-lg-3 wow fadeInRight" data-wow-delay="400ms" style={{ visibility: "visible", animationDelay: "400ms", animationName: "fadeInRight" }}>
              <a href="javascript:void(0);">
                <div class="card box text-center">
                  <div class="feature-icon text-center">
                    <img src="assets/home/team.png" alt="icon" />
                  </div>
                  <div class="card-body">
                    <p class="card-text sub-heading text-black">Partnership with Top Companies</p>
                  </div>
                </div>
              </a>
            </div>

            <div class="col-12 col-lg-3 wow fadeInRight" data-wow-delay="400ms" style={{ visibility: "visible", animationDelay: "400ms", animationName: "fadeInRight" }}>
              <a href="javascript:void(0);">
                <div class="card box text-center">
                  <div class="feature-icon text-center">
                    <img src="assets/home/technical-support.png" alt="icon" />
                  </div>
                  <div class="card-body">
                    <p class="card-text sub-heading text-black">Hassle-Free<br />Services</p>
                  </div>
                </div>
              </a>
            </div>

          </div>
        </div>
      </section>


      <section className="campusrozgar">
        <div className="container">
          <div className="row">
            <div class="col-lg-5">
              <div class="img-box4">
                <div class="ripple-thumb img-1">
                  <div class="ripple"></div>
                  <div class="ripple"></div>
                  <div class="ripple"></div>
                  <div class="ripple"></div>
                  <div class="ripple-img"><img src="assets/img/ab-5-1.jpg" alt="image" /></div>
                </div>
                <div class="ripple-thumb img-2">
                  <div class="ripple-img"><img src="assets/img/ab-5-2.jpg" alt="image" /></div>
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <div className="taglines">
                {/* <h6>One of the trusted portals for employers and universities.</h6>
                        <h6>One-stop solution for universities and employers for quick recruitment.</h6>
                        <h6>Source new companies for placement drive across the entire state.</h6>
                        <h6>Helps to improve placement records.</h6>
                        <h6>Fulfills all your demands and ensures the qualitative result.</h6> */}
                <h1 className="heading pt-4">
                  Why to Register on Campus Rozgar?
                </h1>
                <ul>
                  <li className="mb-2">
                    One of the trusted portals for employers and universities.
                  </li>
                  <li className="mb-2">
                    One-stop solution for universities and employers for quick
                    recruitment.
                  </li>
                  <li className="mb-2">
                    Source new companies for placement drive across the entire
                    state.
                  </li>
                  <li className="mb-2">Helps to improve placement records.</li>
                  <li className="mb-2">
                    Fulfills all your demands and ensures the qualitative
                    result.
                  </li>
                </ul>
              </div>
              <a className="send-button my-5" href='/ContactUs'>Send Enquiry</a>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray">
        <div className="container">
          <h1 className="heading d-flex justify-content-center">
            Our Collaborations
          </h1>
          <div className="owl-carousel owl-theme py-3" id="collab-carousel">
            <div className="item">
              <img
                src="/assets/home/acc-logo.jpg"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/home/hdfc-logo.jpg"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/home/honda-logo.jpg"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/home/hcl-logo.jpg"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/home/icici-logo.jpg"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/home/iica-logo.jpg"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/home/ima-logo.jpg"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="item">
              <img
                src="/assets/home/rbl-logo.jpg"
                alt=""
                className="img-fluid"
              />
            </div>

          </div>
        </div>
      </section>


      <section class="testimonial">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 d-none d-lg-block">
              <ol class="carousel-indicators tabs">
                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active">
                  <figure>
                    <img src="assets/img/testimonials-02.png" class="img-fluid" alt="" />
                  </figure>
                </li>
                <li data-target="#carouselExampleIndicators" data-slide-to="1">
                  <figure>
                    <img src="assets/img/testimonials-01.png" class="img-fluid" alt="" />
                  </figure>
                </li>
                <li data-target="#carouselExampleIndicators" data-slide-to="2">
                  <figure>
                    <img src="assets/img/testimonials-03.png" class="img-fluid" alt="" />
                  </figure>
                </li>
              </ol>
            </div>
            <div class="col-lg-8 d-flex justify-content-center align-items-center">
              <div id="carouselExampleIndicators" data-interval="false" class="carousel slide" data-ride="carousel">
                <h3>What They Say?</h3>
                <h1>Testimonials</h1>
                <p>Rozgar has got more than 100+ positive ratings from our users.</p>
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <div class="quote-wrapper">
                      <p>"I would like to extend my gratitude and sincerest thanks for all the support provided during my recruitment process at Dunnhumby.It was a seamless experience for me from the day I got a call to the day I got recruited.You have excellent consultants who know getting the right professional for the right job.This intrigue process is made so simple not just for a professional but also for the companies who are looking forward to hire the right candidates."</p>
                      <h3>Harshit Gupta</h3>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="quote-wrapper">
                      <p>"I would like to extend my gratitude and sincerest thanks for all the support provided during my recruitment process at Dunnhumby.It was a seamless experience for me from the day I got a call to the day I got recruited.You have excellent consultants who know getting the right professional for the right job.This intrigue process is made so simple not just for a professional but also for the companies who are looking forward to hire the right candidates."</p>
                      <h3>Harshit Gupta</h3>
                    </div>
                  </div>
                  <div class="carousel-item">
                    <div class="quote-wrapper">
                      <p>"I would like to extend my gratitude and sincerest thanks for all the support provided during my recruitment process at Dunnhumby.It was a seamless experience for me from the day I got a call to the day I got recruited.You have excellent consultants who know getting the right professional for the right job.This intrigue process is made so simple not just for a professional but also for the companies who are looking forward to hire the right candidates."</p>
                      <h3>Harshit Gupta</h3>
                    </div>
                  </div>
                </div>
                <ol class="carousel-indicators indicators">
                  <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                  <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="sw_our_newsletter_wrapper">
          <div class="container">
            <div class="row">
              <div class="col-md-7 col-lg-7 col-sm-12 col-xs-12">
                <div class="sw_nl_heading_wrapper sw_our_news_txt">
                  <i class="flaticon-rocket"></i>
                  <h2>Get Rozgar app link on your mobile</h2>
                  <h6>Get Rozgar app link on your mobile</h6>
                  <div class="prs_newsletter_field">
                    <input type="text" placeholder="Enter mobile number......" className={mobile.error.length > 0 && mobile.value.length < 10 && "error"} name={'mobile'} value={mobile.value} onChange={(e) => {
                      if (e.target.value.length <= 10 && !isNaN(e.target.value)) {
                        setMobile({ ...mobile, value: e.target.value })
                      }
                    }} />
                    <button type="submit" class="waves-effect waves-light waves-ripple" onClick={() => { sendLink() }}>Get link</button>
                  </div>
                  {mobile.success.length > 0 && <span className="text-success">{mobile.success}</span>}

                  {mobile.error.length > 0 && mobile.value.length < 10 && <span className="text-danger">{mobile.error}</span>}
                  <div className="mobileappbox">
                    <a target='_blank' href='https://play.google.com/store/apps/details?id=com.app.rozgar'>
                      <img src={'./assets/home/google-app.png'} /></a>
                    <a target='_blank' href='https://apps.apple.com/app/id6445827267'>
                      <img src={'./assets/home/iso-app.png'} /></a>
                  </div>
                </div>
              </div>
              <div class="col-md-5 col-lg-5 col-sm-12 col-xs-12">
                <div class="sw_letter_img_wrapper wow  zoomIn  animated" data-wow-duration="1.3s" style={{ visibility: 'visible', animationDuration: '1.3s', animationName: 'zoomIn' }}>
                  <img src={'./assets/home/abt_ltr_img.png'} alt="img" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="secttionLocation">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ul className="citylocaiton">
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/mumbai"> Jobs in Mumbai City</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/delhi"> Jobs in Delhi</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/gurugram"> Jobs in Gurugram</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/noida"> Jobs in Noida</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/chennai"> Jobs in Chennai</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/pune"> Jobs in Pune</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/hyderabad"> Jobs in Hyderabad</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/ahmedabad"> Jobs in Ahmedabad</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/lucknow"> Jobs in Lucknow</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/chandigarh"> Jobs in Chandigarh</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/jammu"> Jobs in Jammu</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/udaipur"> Jobs in Udaipur</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/bhubaneshwar"> Jobs in Bhubaneshwar</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/bhopal"> Jobs in Bhopal</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/bareilly"> Jobs in Bareilly</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/cuttack"> Jobs in Cuttack</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/jhansi"> Jobs in Jhansi</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/gaya"> Jobs in Gaya</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/patna"> Jobs in Patna</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/moradabad"> Jobs in Moradabad</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/nicobar"> Jobs in Nicobar</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/siliguri"> Jobs in Siliguri</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/tirunelveli"> Jobs in Tirunelveli</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/thane"> Jobs in Thane</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/vadodara"> Jobs in Vadodara</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/nashik"> Jobs in Nashik</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/manglore"> Jobs in Manglore</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/ujjain"> Jobs in Ujjain</a></li>
                <li><i class="fa fa-map-marker"></i> <a data-interception="off" target="_blank" href="https://rozgar.com/jobs/location/coimbatore"> Jobs in Coimbatore</a></li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <footer class="footer-area">
        <div class="footer-top footer-top-style">
          <div class="container">
            <div class="row justify-content-between">
              <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Jobs</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a target='_blank' href="https://rozgar.com/">Search jobs</a></li>
                      <li><a target='_blank' href="https://rozgar.com/register">Register now</a></li>
                      <li><a target='_blank' href="https://rozgar.com/jobs-by-location">Jobs by location</a></li>
                      <li><a target='_blank' href="https://rozgar.com/browse-jobs">Browse all jobs</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  {/* <div class="footer-title footer-title-style2">
                    <h3>&nbsp;</h3>
                  </div> */}
                  <h3>&nbsp;</h3>
                  <div class="item-link pt-3">
                    <ul>
                      <li><a target='_blank' href="https://rozgar.com/jobs-by-skill">Jobs by skill</a></li>
                      <li><a target='_blank' href="https://rozgar.com/jobs-by-designation">Jobs by designation</a></li>
                      <li><a target='_blank' href="https://rozgar.com/jobs-by-company">Jobs by company</a></li>
                      <li><a target='_blank' href="https://rozgar.com/jobs-by-category">Jobs by category</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2 min50">
                  <div class="footer-title footer-title-style2">
                    <h3>Freshers Jobs</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a target='_blank' href="https://rozgar.com/jobs/fresher">Latest fresher jobs</a></li>
                      <li><a href="javascript:void(0)">Students</a></li>
                      <li><a href="javascript:void(0)">Institution</a></li>
                      <li><a href="javascript:void(0)">Hiring company</a></li>
                      <li><a href="javascript:void(0)">Internships</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Companies</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a target='_blank' href="https://rozgar.com/list/companies">Browse all companies</a></li>
                      <li><a target='_blank' href="https://rozgar.com/top-companies">Top companies</a></li>
                      <li><a target='_blank' href="https://rozgar.com/top-companies">Company reviews</a></li>
                      <li><a target='_blank' href="https://rozgar.com/interview-questions">Interview questions</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Services</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a target='_blank' href="https://rozgar.com/resume-making">Resume Creation</a></li>
                      <li><a target='_blank' href="https://rozgar.com/study-abroad">Study abroad</a></li>
                      <li><a target='_blank' href="https://rozgar.com/under-maintainance-Students-benefits">Students benefits</a></li>
                      <li><a target='_blank' href="https://rozgar.com/career-astrology">Career Astrology</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-between mt-5">
              <div class="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                <div class="footer-logo-area footer-logo-area-2">
                  <div class="item-logo">
                    <img src="/assets/home/rozgar.png" width="157" height="40" alt="logo" class="img-fluid" />
                  </div>
                  <div class="footer-contact footer-contact-style-2">
                    <div class="footer-location">
                      <ul>
                        <li class="item-map">
                          <i class="fas fa-map-marker-alt"></i> A-51 Sector 16 Noida, U.P. - 201301
                        </li>
                        <li>
                          <a href="mailto:contact@rozgar.com"><i class="fas fa-envelope"></i> contact@rozgar.com</a>
                        </li>
                        <li>
                          <a href="tel:+9177770 04946"><i class="fas fa-phone-alt"></i> +91 77770 04946</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <h5 className="text-white">Connect with us</h5>
                  <div class="item-social">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/RozgarGlobal/" target="_blank"><i class="fab fa-facebook-f"></i></a>
                      </li>
                      <li>
                        <a href="https://twitter.com/rozgar_india" target="_blank"><i class="fab fa-twitter"></i></a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/company/rozgar" target="_blank"><i class="fab fa-linkedin"></i></a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/rozgarofficial/?hl=en" target="_blank"><i class="fab fa-instagram"></i></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Quick Links</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a target='_blank' href="https://recruit.rozgar.com/job-post">Post a Job</a></li>
                      <li><a target='_blank' href="https://rozgar.com/list/companies">Companies</a></li>
                      <li><a target='_blank' href="/login">Log In</a></li>

                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2 min50">
                  <div class="footer-title footer-title-style2">
                    <h3>Let's begin your search</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a target='_blank' href="https://rozgar.com/jobs-by-location">Explore cities</a></li>
                      <li><a target='_blank' href="https://rozgar.com/discussion-forum">Discussion forum</a></li>
                      <li><a target='_blank' href="https://rozgar.com/report-a-problem">Report an issue</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Resource centre</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a target='_blank' href="/AboutUs">About Us</a></li>
                      <li><a target='_blank' href="https://rozgar.com/resume-making#createtemplate">Resume samples</a></li>
                      <li><a target='_blank' href="https://rozgar.com/blog">Blog</a></li>
                      <li><a target='_blank' href="https://rozgar.com/faq">FAQs</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6">
                <div class="footer-link footer-link-style-2">
                  <div class="footer-title footer-title-style2">
                    <h3>Employer Zone</h3>
                  </div>
                  <div class="item-link">
                    <ul>
                      <li><a target='_blank' href="https://recruit.rozgar.com/subscriptions">Buy online</a></li>
                      <li><a target='_blank' href="https://recruit.rozgar.com/">Employer login</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom footer-bottom-style-2">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-lg-12 col-md-12 text-center">
                <div class="copyright-area2">
                  <p>Copyright © 2021-22 Rozgar.com. All Rights Reserved | Powered by <a target='_blank' className="powercom" href="https://www.valueinnovationlabs.com/">Value Innovation Pvt. Ltd.</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </React.Fragment >
  );
};

export default HomePageLayouts;
